export const environment = {
  production: false,
  publicKey: 'BV4JUegeYvtWCSarKvRF3B8Wc+Zoyl4dZ7G8VCWm2RB=',
};
